const readMoreButtons = document.querySelectorAll(".event-read-more");
const descriptions = document.querySelectorAll(".event-description");

for (let i = 0; i < readMoreButtons.length; i++) {
    readMoreButtons[i].addEventListener("click", (e) => {
        if (descriptions[i].classList.contains("collapsed")) {
            descriptions[i].classList.remove("collapsed");
            readMoreButtons[i].textContent = "Read less";
        } else {
            descriptions[i].classList.add("collapsed");
            readMoreButtons[i].textContent = "Read more";
        }
    })
}